var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 21.7601C10.3489 22.6295 11.9512 23.137 13.6725 23.137C19.3318 23.137 22.529 18.3319 22.3363 14.0223C22.9317 13.5908 23.4486 13.0513 23.8571 12.4363C23.3103 12.68 22.7229 12.8447 22.1066 12.9185C22.7357 12.5401 23.219 11.9394 23.4464 11.2235C22.8576 11.5747 22.2052 11.8297 21.5112 11.9673C20.9552 11.3717 20.163 11 19.2861 11C17.3188 11 15.8728 12.8455 16.317 14.7621C13.7838 14.6344 11.5376 13.4146 10.0346 11.5604C9.23583 12.9379 9.62025 14.7397 10.9779 15.6516C10.4782 15.6359 10.0076 15.4975 9.59689 15.2682C9.56403 16.6879 10.5756 18.0152 12.0417 18.3114C11.6124 18.4288 11.1426 18.4552 10.6654 18.3635C11.0528 19.5814 12.1786 20.4666 13.5126 20.4915C12.2316 21.5014 10.6172 21.952 9 21.7601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.5e6c9c7bafb235816198da96af6de41a.svg";
export { ForwardRef as ReactComponent };